export default "__VITE_ASSET__CaUQ_w10__"